// @ts-nocheck
import { AdminTemplate, MerchantGoldBindingForm } from "../../components"

export const MerchantGoldBinding = () => {
    return (
        <AdminTemplate
            headerProps={{
                headerTitle: 'Altın Bağlantı',
                hideAddButton: true,
                hideDownloadButton: true,
                hideSearchBar: false
            }}>
            <MerchantGoldBindingForm />
        </AdminTemplate>
    )
}